import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'syn-loader',
  templateUrl: './loader.component.html',
})
export class LoaderComponent {}
